/**
 * A UserTypes enumarator for specifing a user type
 * @type {{paying: string, registered: string, anonymous: string}}
 */
export const UserTypes = {
  paying: 'paying',
  registered: 'registered',
  anonymous: 'anonymous',
};
/**
 * An object that represents a user instance
 * Must be constructed with an explicit type:
 *
 */
export default class User {
  constructor(userOptions) {
    if (!userOptions) {
      throw new Error('Required parameter missing: userOptions');
    }
    if (!userOptions.type && !userOptions.userType) {
      throw new Error('Required parameter missing: userOptions.type and userOptions.userType');
    }
    // if (!userOptions.anonymousId) {
    //   throw new Error('Required parameter missing: userOptions.anonymousId');
    // }
    this.type = userOptions.userType || userOptions.type;
    if (this.type === UserTypes.anonymous) {
      this.anonymousId = userOptions.anonymousId || null;
    }
    else if (
      this.type === UserTypes.registered
      || this.type === UserTypes.paying
    ) {
      this.anonymousId = userOptions.anonymousId;
      this.email = userOptions.userMail;
      this.firstName = userOptions.firstName;
      this.lastName = userOptions.lastName;
      this.emailStatus = userOptions.emailValidity;
      this.university = userOptions.university === true || userOptions.university === 'true';
      this.extendedUserType = userOptions.extendedUserType;
    }
    else {
      throw new Error('Unsupported User Type');
    }
    /* this.premiumArticlesCount =
    (cookieAsMap.get('HtzRusr') ?
    parseInt(cookieAsMap.get('HtzRusr'), 10) : -1); */
  }
}
